import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
    ApplicationDetails_Create,
    ApplicationDetails_Update,
    ApplicationDetails_Delete,
    ApplicationDetails_ReadAll,
    ApplicationDetails_ReadById,
    ApplicationDetails_ReadByApplicationId,
    ApplicationDetails_ReadByParameterId,
    ApplicationDetails_CreateByParameters,
    ApplicationDetails_UpdateByParameterName
} from "src/app/GlobalVariable";
import { ApplicationDetailsCreateRequestDTO, ApplicationDetailsDTO, ApplicationDetailsUpdateRequestDTO, ApplicationDetailsList, ApplicationDetailsDeleteRequestDTO, ApplicationDetailsReadByIdRequestDTO, ApplicationDetailsReadByApplicationIdRequestDTO, ApplicationDetailsReadByParameterIdRequestDTO, ApplicationDetailsCreateByParametersRequest, ApplicationDetailsCreateByParametersResponseDTO, ApplicationDetailsUpdateByParameterNameRequestDTO, ApplicationDetailsUpdateByParameterNameResponseDTO, ApplicationDetailsResponseDTO } from "./loan-application-details.interface";

@Injectable({
    providedIn: 'root'
})
export class ApplicationDetailsService {

    private http = inject(HttpClient);

    ApplicationDetails_Create(data: ApplicationDetailsCreateRequestDTO): Observable<ApplicationDetailsDTO> {
        return this.http.post<ApplicationDetailsDTO>(ApplicationDetails_Create, data);
    }

    ApplicationDetails_Update(data: ApplicationDetailsUpdateRequestDTO): Observable<ApplicationDetailsDTO> {
        return this.http.post<ApplicationDetailsDTO>(ApplicationDetails_Update, data);
    }

    ApplicationDetails_ReadAll(): Observable<ApplicationDetailsList> {
        return this.http.get<ApplicationDetailsList>(ApplicationDetails_ReadAll);
    }

    ApplicationDetails_Delete(data: ApplicationDetailsDeleteRequestDTO): Observable<void> {
        return this.http.post<void>(ApplicationDetails_Delete,data);
    }

    ApplicationDetails_ReadById(data: ApplicationDetailsReadByIdRequestDTO): Observable<ApplicationDetailsDTO> {
        return this.http.post<ApplicationDetailsDTO>(ApplicationDetails_ReadById,data);
    }

    ApplicationDetails_ReadByApplicationId(data: ApplicationDetailsReadByApplicationIdRequestDTO): Observable<ApplicationDetailsResponseDTO> {
        return this.http.post<ApplicationDetailsResponseDTO>(ApplicationDetails_ReadByApplicationId,data);
    }

    ApplicationDetails_ReadByParameterId(data: ApplicationDetailsReadByParameterIdRequestDTO): Observable<ApplicationDetailsDTO> {
        return this.http.post<ApplicationDetailsDTO>(ApplicationDetails_ReadByParameterId,data);
    }

    ApplicationDetails_CreateByParameters(data: ApplicationDetailsCreateByParametersRequest): Observable<ApplicationDetailsCreateByParametersResponseDTO> {
        return this.http.post<ApplicationDetailsCreateByParametersResponseDTO>(ApplicationDetails_CreateByParameters, data)
    }

    ApplicationDetails_UpdateByParameterName(data: ApplicationDetailsUpdateByParameterNameRequestDTO): Observable<ApplicationDetailsUpdateByParameterNameResponseDTO> {
        return this.http.post<ApplicationDetailsUpdateByParameterNameResponseDTO>(ApplicationDetails_UpdateByParameterName, data)
    }
}
